import { ConverterRegistry } from '../../core/converter';
import { DocxDocumentConverter, type DocxConverterDeps } from './docx-converter';
import { PdfDocumentConverter, type PdfConverterDeps } from './pdf-converter';
import { SpreadsheetDocumentConverter, type SpreadsheetConverterDeps } from './spreadsheet-converter';
import { StructuredDocumentConverter } from './structured-converter';
import { TextDocumentConverter } from './text-converter';

/** 文档引擎的可注入依赖：测试用假实现替换重量级解析库（pdf.js / mammoth / SheetJS）。 */
export interface DocumentEngineDeps {
  pdf?: PdfConverterDeps;
  docx?: DocxConverterDeps;
  spreadsheet?: SpreadsheetConverterDeps;
}

/**
 * 注册顺序即 `resolve()` 的优先级：本地引擎全部排在 AI 通道之前，
 * 保证「同一个目标格式既有本地又有 AI 时，默认走本地、不产生上传与扣费」。
 */
export function registerDocumentEngines(registry: ConverterRegistry, deps: DocumentEngineDeps = {}): ConverterRegistry {
  registry.register(new TextDocumentConverter());
  registry.register(new StructuredDocumentConverter());
  registry.register(new PdfDocumentConverter(deps.pdf));
  registry.register(new DocxDocumentConverter(deps.docx));
  registry.register(new SpreadsheetDocumentConverter(deps.spreadsheet));
  return registry;
}

export function createDocumentRegistry(deps: DocumentEngineDeps = {}): ConverterRegistry {
  return registerDocumentEngines(new ConverterRegistry(), deps);
}
